import * as React from 'react';
import * as moment from 'moment';

interface Props {
  dateTime: moment.Moment
}
export default class DisplayDate extends React.Component<Props> {
  
  render() {
    const { dateTime } = this.props;
    return (
        moment(dateTime).format('DD/MM/YYYY')
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/DisplayDate.tsx